module.exports = __webpack_public_path__ + "static/img/lighting.bc126fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/waterSystem/waterSystemHome/img/lighting.png
// module id = 3+CU
// module chunks = 163